module.exports = __webpack_public_path__ + "static/media/cp6.a3df2033.png";